import { ApplicationRef, Component, inject, Inject, Optional, PLATFORM_ID, TransferState } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from './shared/services/common.service';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from './shared/services/seo.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { isDevMode } from '@angular/core';
import { environment } from '@/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { first, firstValueFrom } from 'rxjs';
import { CLIENT_IP, CONFIG_DATA } from './shared/services/auth.service';
import { SERVER_SEO_DATA } from '@/express.tokens';
import { ThemeOption } from './shared/interface/common.interface';
import { HomeConfigurationService } from './shared/services/homeconfiguration.service';
import { TrackingService } from './shared/services/tracking.service';
import { ConfigurationV2Service } from './shared/services/configuration-v2.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'ecrms-frontend-angular';

  // private appRef = inject(ApplicationRef);
  
  constructor(
    // private translateService: TranslateService,
    private commonService: CommonService,
    private meta: Meta,
    private titleService: Title,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private deviceService: DeviceDetectorService,
    private transferState: TransferState,
    @Optional() @Inject(SERVER_SEO_DATA) private seoData: any,
    private homeConfigurationService: HomeConfigurationService,
    private tracking: TrackingService,
    private configV2Service: ConfigurationV2Service,
  ) {
    // this.translateService.setDefaultLang('en');
    // this.translateService.use('en');

    // if (typeof window === 'undefined') {
    //   this.appRef.isStable.subscribe(stable => {
    //     console.log(`[SSR Debug] Application Stable State changed to: ${stable}`);
    //   });
    // }
  }

  ngOnInit() {
    // this.seoService.generateTags({});
    // home-config từ CMS có thể thiếu seo / og_image: không được làm hỏng SSR mọi trang.
    const seo = this.seoData?.seo;
    if (seo && !isPlatformBrowser(this.platformId)) {
      this.seoService.generateTags({
          image: seo.og_image?.original_url,
          title: seo.meta_title,
          metaTitle: seo.meta_title,
          description: seo.meta_description
        });
    }

    if (isPlatformBrowser(this.platformId)) {
      this.commonService.deviceInfo = this.deviceService.getDeviceInfo();
      // Chính sách ghi event (bật/tắt, từng loại event, chia mẫu) lấy từ ConfigurationV2, một lần khi tải trang.
      // SDK tự kiểm tra nội dung; lỗi hoặc chưa có config thì tắt.
      const et: any = environment.eventTracking;
      if (et?.enabled && et?.configName) {
        this.configV2Service.getConfigrationV2(et.configName).subscribe({
          next: (res: any) => this.tracking.applyPolicy(res?.[0]?.configJsonValue ?? null),
          error: () => this.tracking.applyPolicy(null),
        });
      }
      // Khách đã đăng nhập từ trước: nối lại thiết bị với người dùng
      this.tracking.identifyIfLoggedIn();
      // Ghi cta_clicked cho các nút có thuộc tính data-cta
      this.tracking.watchClicks();
    }
    // else {
    //   console.log('fetching config data');
    //   this.homeConfigurationService.getHomeConfigInfo().subscribe({
    //     next: (res: ThemeOption) => {
    //       if (res && res.options) {
    //       this.seoService.generateTags({
    //           image: res.options.seo.og_image.original_url,
    //           title: res.options.seo.meta_title,
    //           metaTitle: res.options.seo.meta_title,
    //           description: res.options.seo.meta_description
    //         });
    //       }
    //       this.transferState.set(CONFIG_DATA, res);
    //     },
    //     error: (error) => {
    //       console.log(error);
    //     }
    //   });
    // }

    this.meta.addTag({
      name: "keywords",
      property: "keywords",
      content: "Thuốc, Dược phẩm, Mỹ phẩm, Thiết bị y tế, Dược Vương",
    });
    this.meta.addTag({
      name: "author",
      property: "author",
      content: "Giá thuốc tốt",
    });
    if (this.isDevelopmentMode()) {
      this.meta.updateTag({
        name: "robots",
        content: "noindex, nofollow, max-snippet:-1, max-image-preview:standard, max-video-preview:-1",
      });
    }
    else {
      this.meta.updateTag({
        name: "robots",
        content: "index, follow, max-snippet:-1, max-image-preview:standard, max-video-preview:-1",
      });
    }

    if (isPlatformBrowser(this.platformId)) {
      if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
        this.meta.updateTag({
          name: 'viewport',
          content: "width=device-width, initial-scale=1, maximum-scale=1"
        });
      }

      if (environment.environment === 'production') {
        const script = document.createElement('script');
        //Meta Pixel Code
        script.innerHTML = `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '8877894212305889');
          fbq('track', 'PageView');
        `;
        //End Meta Pixel Code
        document.head.appendChild(script);

        const noscript = document.createElement('noscript');
        noscript.innerHTML = `
          <img height="1" width="1" style="display:none"
            src="https://www.facebook.com/tr?id=8877894212305889&ev=PageView&noscript=1" />
        `;
        document.head.appendChild(noscript);
      }
    }

    // this.commonService.getTitle
    //   .pipe(isPlatformBrowser(this.platformId) ? (source) => source : first())
    //   .subscribe({
    //     next: (title: string) => {
    //       if (title) {
    //         this.titleService.setTitle(title);
    //       }
    //       else {
    //         this.titleService.setTitle("Giá Thuốc Tốt - “Nhanh chóng – An toàn – Hiệu quả”");
    //       }
    //     }
    //   });

    if (this.isDevelopmentMode()) {
      this.document.documentElement.style.setProperty('--theme-color', '#1d73c4');
      this.document.documentElement.style.setProperty('--theme-color-linear', '#1d87eb');
    }
  }

  isDevelopmentMode(): boolean {
    return !environment.production;
  }

}